import tableManagementGroupReducer from './group'
import tableManagementMapReducer from './map'
import tableManagementReportReducer from './report'
import tableManagementSubscriptionReducer from './tableManagementSubscription'

export {
  tableManagementGroupReducer,
  tableManagementMapReducer,
  tableManagementReportReducer,
  tableManagementSubscriptionReducer
}



// WEBPACK FOOTER //
// ./app/reducers/tableManagement/index.js